export function IsoBadge({ dark = true, testId = "iso-badge" }) {
  const fg = dark ? "#E2E8F0" : "#0A2540";
  const sub = dark ? "#94A3B8" : "#475569";
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid={testId} title="Sistema di Gestione della Sicurezza delle Informazioni conforme a ISO/IEC 27001:2022">
      <svg width="40" height="40" viewBox="0 0 64 64" aria-hidden="true">
        <circle cx="32" cy="32" r="30" fill="none" stroke="#38BDF8" strokeWidth="3" />
        <circle cx="32" cy="32" r="24" fill="none" stroke={fg} strokeWidth="1" opacity="0.4" />
        <path d="M32 14 L46 20 V31 C46 40 40 47 32 50 C24 47 18 40 18 31 V20 Z" fill="#0A2540" stroke="#38BDF8" strokeWidth="2" />
        <path d="M25 32 L30 37 L40 26" fill="none" stroke="#38BDF8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div className="leading-tight">
        <p className="font-heading text-[13px] font-bold tracking-wide" style={{ color: fg }}>ISO/IEC 27001</p>
        <p className="text-[10px] uppercase tracking-[0.14em]" style={{ color: sub }}>Certificato DNV · ed. 2022</p>
      </div>
    </div>
  );
}
